import router from "@/router";
import { AxiosRequestConfig, AxiosResponse } from "axios";

export default abstract class AxiosClient {
  protected transformResult(_url: string, response: AxiosResponse, processor: (response: AxiosResponse) => any) {
    switch (response.status) {
      case 401:
        router.push({ name: "login" });
        break;
    }

    return processor(response);
  }

  protected transformOptions(options: AxiosRequestConfig) {
    return Promise.resolve(options);
  }
}
